import React, {useState} from "react";
import {
    Typography,
    Grid,
    Button,
    makeStyles,
    Container
} from "@material-ui/core";
import {ReactComponent as WelcomeSVG} from "../../../Images/welcomeImage.svg";
import {ReactComponent as SubscriptionSVG} from "../../../Images/welcomeSubscriptionImage.svg";
import {useHistory} from "react-router-dom";
import {statesWithoutPrescription} from "../../../Constants/locations";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {bootIntercom} from "../../../hooks/useIntercom";
import API from "../../../helpers/apiHelpers";
import Image from "material-ui-image";

interface Props {
    pet: any;
    isOnBoarding: boolean;
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
    hasSubscription?: boolean;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 50,
        paddingBottom: 40,
        display: "flex",
        justifyContent: "center"
    },
}));

const Offer = ({pet, isOnBoarding, setIsOnBoarding, hasSubscription = false}: Props) => {
    let history = useHistory();
    const classes = useStyle();
    const location = useSelector((state: RootState) => state?.common.location);
    const [bundle, setBundle] = useState(false);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const logo = useSelector((state: RootState) => state?.branding.logo);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (location) {
            setBundle(!statesWithoutPrescription.some(item => item.value === location));
        }
    }, [location]);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h2">
                        Congratulations you are all set up!
                    </Typography>
                </Grid>
                <Grid item xs={12} className={classes.spacingImage}>
                    {hasSubscription ? <SubscriptionSVG style={{width: "100%"}}/> :
                        isWhiteLabel ?
                            <Image
                                src={pet.imageUrl}
                                errorIcon={<img src={logo} width="100%"/>}
                                style={{width: "50%", paddingTop: 0, position: "relative"}}
                                imageStyle={{height: "100%", position: "relative"}}/>:
                            <WelcomeSVG style={{width: "100%"}}/>}
                </Grid>
                {!hasSubscription &&
                <>
                    <Grid item xs={12}>
                        <Typography variant="h5" className={classes.spacing}>
                            {bundle ?
                                (isWhiteLabel ?
                                    "We are so excited for you to meet our amazing veterinarians!"
                                    :
                                    "Are you seeking a prescription with your visit? Find out how you can bundle and save up to 24%"
                                )
                                : "We are so excited for you to meet our amazing veterinarians!"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        {bundle ?
                            null
                            :
                            (isWhiteLabel ?
                                null
                                :
                                <Typography variant="h5" className={classes.spacing}>Book now and receive <b>15%
                                        off</b> with coupon code PET15.</Typography>
                            )
                        }
                    </Grid>
                </>
                }
                {bundle && !hasSubscription && !isWhiteLabel &&
                <Grid item xs={12} className={classes.spacing}>
                    <Button
                        fullWidth
                        color="secondary"
                        variant="outlined"
                        onClick={() => {
                            bootIntercom(API.userId, JSON.parse(localStorage.getItem("auth")).email);
                            history.push("/purchaseCredits");
                        }}
                    >
                        Learn More & Save
                    </Button>
                </Grid>
                }
                <Grid item xs={12} className={classes.spacing}>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            if (isOnBoarding) {
                                setIsOnBoarding(false);
                                document.cookie = "isOnBoarding= ; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                            }
                            bootIntercom(API.userId, JSON.parse(localStorage.getItem("auth")).email);
                            history.push("/schedule");
                        }}
                    >
                        Schedule Now
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Offer;
